import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { ExclamationCircleIcon, InformationCircleIcon } from "@heroicons/react/24/outline";
export function Alert({ children: message, title, info = false }) {
    return /*#__PURE__*/ _jsxs("div", {
        className: `flex justify-between items-center ${info ? "bg-gray-200" : "bg-red-100"} rounded-md pl-8 p-4`,
        children: [
            info ? /*#__PURE__*/ _jsx(InformationCircleIcon, {
                className: "w-10 h-10"
            }) : /*#__PURE__*/ _jsx(ExclamationCircleIcon, {
                className: "w-10 h-10"
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex grow flex-col gap-2 pl-8",
                children: [
                    /*#__PURE__*/ _jsx("h3", {
                        className: "text-sm font-bold text-black",
                        children: title
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "text-sm text-black font-extralight",
                        children: message
                    })
                ]
            })
        ]
    });
}
